import React from 'react';
import { css } from '@emotion/react';

export interface sectionTitles {
  enText: String;
  jaText?: String;
  textWhite?: Boolean;
}

const SectionTitle: React.FC<sectionTitles> = ({ enText, jaText, textWhite = false }) => {
  const titleClass = textWhite ? 'section-title-wrap c-white' : 'section-title-wrap';
  return (
    <div className={titleClass} css={titleStyle}>
      <p className="section-title-en">{enText}</p>
      <h2 className="section-title-ja">{jaText}</h2>
    </div>
  );
};

const titleStyle = css`
  text-align: center;
  margin: 0 0 2.5rem;
  .section-title-en {
    font-size: 2.15em;
    line-height: 1.5;
    letter-spacing: 0.12em;
    font-weight: 900;
    font-family: 'Montserrat', serif;
    color: #35187e;
    position: relative;
    padding: 0 0 20px;
    box-sizing: border-box;
    &::before {
      content: '';
      width: 90px;
      height: 4px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0.65rem;
      margin: auto;
      background: rgb(236, 143, 188);
      background: linear-gradient(90deg, rgba(236, 143, 188, 1) 0%, rgba(179, 235, 251, 1) 100%);
    }
  }
  .section-title-ja {
    font-size: 1.1em;
    line-height: 1.5;
    color: #35187e;
    font-weight: 700;
  }

  &.c-white {
    .section-title-en,
    .section-title-ja {
      color: #fff;
    }

    .section-title-en {
      &::before {
        background: #fff;
      }
    }
  }

  @media (max-width: 767px) {
    margin: 0 0 30px;
    .section-title-en {
      font-size: 1.8em;
      padding: 0 0 14px;
      &::before {
        width: 45px;
        height: 3px;
        bottom: 8px;
      }
    }

    .section-title-ja {
      font-size: 1em;
    }
  }
`;

export default SectionTitle;
